<template>
  <component :is="pageComponent" />
</template>

<script>
import LayoutPrimary from '@/mixins/LayoutPrimary'
import FaqAndSupportDesktop from '~/components/Page/FaqAndSupport/FaqAndSupportDesktop.vue'
import FaqAndSupportMobile from '~/components/Page/FaqAndSupport/FaqAndSupportMobile.vue'
import { getOpenGraphMeta } from '@/helpers/openGraph'

export default {
  name: 'FaqAndSupportPage',
  mixins: [LayoutPrimary],
  head() {
    return {
      title: 'FAQ и поддержка - МТС Линк',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Ответы на часто задаваемые вопросы и техническая поддержка сервиса МТС Линк.',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'FAQ',
        },
        ...getOpenGraphMeta({
          title: 'FAQ и поддержка - МТС Линк',
          description:
            'Ответы на часто задаваемые вопросы и техническая поддержка сервиса МТС Линк.',
          path: '/faq_and_support/',
        }),
      ],
      bodyAttrs: {
        class: 'grey-body',
      },
    }
  },
  computed: {
    pageComponent() {
      return this.$device.isDesktop ? FaqAndSupportDesktop : FaqAndSupportMobile
    },
  },
}
</script>
